import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import injectTapEventPlugin from 'react-tap-event-plugin';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import Home from './app/Home';
import SMSPayment from './app/components/sms_payment';
import Payment from './app/payment';
import '../public/index.css';

import Config from './app/conf';
const Theme = Config.THEME;

injectTapEventPlugin();

// let homeComponent = Config.PAYMENT_TYPE === 'PAYMENT_ONLY' ? Payment : Home;

ReactDOM.render(
  <MuiThemeProvider muiTheme={Theme}>
    <div>
      <BrowserRouter>
        <div>
          <Switch>
            <Route exact path="/payment" component={Payment} />
            <Route path="/payment/:phone" component={Payment} />
            <Route exact path="*" component={Home} />
          </Switch>
        </div>
      </BrowserRouter>
    </div>
  </MuiThemeProvider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js